import { lazy, type ComponentType, type LazyExoticComponent } from "react";

type R = { path: string; Component: LazyExoticComponent<ComponentType> };
const l = (f: () => Promise<{ default: ComponentType }>) => lazy(f);

export const routes: R[] = [
  { path: "/today", Component: l(() => import("./screens/Today")) },
  { path: "/purchases", Component: l(() => import("./screens/purchases/Purchases")) },
  { path: "/purchases/:id", Component: l(() => import("./screens/purchases/Invoice")) },
  { path: "/ready-to-pay", Component: l(() => import("./screens/purchases/ReadyToPay")) },
  { path: "/credits", Component: l(() => import("./screens/purchases/Credits")) },
  // Decision 89 #5: the payments list and payment search (recorded / paid per bank confirmation / paid per notice, not recorded).
  { path: "/payments", Component: l(() => import("./screens/purchases/Payments")) },
  { path: "/items", Component: l(() => import("./screens/purchases/Items")) },
  { path: "/items/:id", Component: l(() => import("./screens/purchases/Item")) },
  { path: "/queries", Component: l(() => import("./screens/Queries")) },
  { path: "/queries/:id", Component: l(() => import("./screens/Queries")) },
  { path: "/proposals", Component: l(() => import("./screens/Proposals")) },
  // Decision 96 #2 and Decision 126 a: every card has its own page, /cards/PR-0010, titled with its number; the old
  // address /proposals/<id> opens the same page.
  { path: "/proposals/:id", Component: l(() => import("./screens/CardPage")) },
  { path: "/cards/:ref", Component: l(() => import("./screens/CardPage")) },
  { path: "/chat", Component: l(() => import("./screens/chat/ChatScreen")) },
  { path: "/inbox", Component: l(() => import("./screens/Inbox")) },
  { path: "/animals", Component: l(() => import("./screens/herd/Animals")) },
  { path: "/herd", Component: l(() => import("./screens/herd/OldHerdAddress")) },
  { path: "/animals/:id", Component: l(() => import("./screens/herd/Animal")) },
  { path: "/map", Component: l(() => import("./screens/herd/MapScreen")) },
  { path: "/places/:id", Component: l(() => import("./screens/herd/Place")) },
  { path: "/receive", Component: l(() => import("./screens/deliveries/ReceiveDelivery")) },
  // Decision 87 #1: the records a search result opens that had no screen of their own.
  { path: "/deliveries/:id", Component: l(() => import("./screens/deliveries/Delivery")) },
  { path: "/documents/:id", Component: l(() => import("./screens/documents/Document")) },
  { path: "/sellers/:id", Component: l(() => import("./screens/sellers/Seller")) },
  { path: "/auctions/:id", Component: l(() => import("./screens/auctions/Auction")) },
  { path: "/quick/:kind", Component: l(() => import("./screens/herd/QuickAction")) },
  { path: "/reconciliation", Component: l(() => import("./screens/herd/Reconciliation")) },
  { path: "/go-live", Component: l(() => import("./screens/herd/GoLive")) },
  { path: "/tasks", Component: l(() => import("./screens/Tasks")) },
  { path: "/reports", Component: l(() => import("./screens/reports/Reports")) },
  { path: "/reports/:key", Component: l(() => import("./screens/reports/Reports")) },
  // Decision 77 d2/e5: the register report, with its one-click export.
  { path: "/register", Component: l(() => import("./screens/reports/Register")) },
  { path: "/settings", Component: l(() => import("./screens/settings/Settings")) },
  { path: "/settings/:section", Component: l(() => import("./screens/settings/Settings")) },
  { path: "/health", Component: l(() => import("./screens/Health")) },
  { path: "/search", Component: l(() => import("./screens/Search")) },
  { path: "/more", Component: l(() => import("./screens/More")) }
];
